import Button from '@components/ui/Button'
import { useExportFile } from '@lib/file'
import { Props } from '@components/ui/Button/Button'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface IExportButtonProps extends Props {
  query?: Record<string, any>
  apiUrl: string
  fileName?: string
  isNotSupportAdmin?: boolean
  extension?:string
}
  //新增extension 
const Export = React.memo<IExportButtonProps>(props => {
  const { t } = useTranslation()
  const {
    query,
    fileName,
    apiUrl,
    extension,
    isNotSupportAdmin = false,
    ...others
  } = props

  const { exportFile } = useExportFile({
    filename: fileName || '',
    apiUrl,
    isNotSupportAdmin,
    extension
  })

  return (
    <Button
      color="ghost"
      onClick={() => exportFile(query)}
      className="ml-16"
      {...others}>
      {t('common:exportCurrentFile')}
    </Button>
  )
})

export default React.memo<Partial<IExportButtonProps>>(props => {
  if (props.fileName) {
    return <Export {...(props as any)} />
  } else {
    return null
  }
})
